import React from "react";
// import gif from "./background (1).gif";
// import img1 from "./1.png";
// import img2 from "./2.png";
import me from "./FaceApp_1689748936900_1.jpg";
import "./mid.css";

const Mid = () => {
  return (
    <div className="mid">
      {/* <img src={img1} alt="img"></img> */}
      <div className="content">
        <span className="left">
          <h1>Hi👋 I'm Anshuman Tiwari</h1>

          <p>MERN Stack || Web Application Developer || DevOps Enthusiast </p>
        </span>
        <span className="right">
          <span className="frame">
            <img src={me} alt="img" className="my-img"></img>
          </span>
        </span>{" "}
      </div>
      {/* <hr /> */}
      {/* <img src={img2} alt="img"></img> */}
    </div>
  );
};

export default Mid;
